import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Loading from '../../../assets/loading.gif';
import 'jquery-ui-dist/jquery-ui';
import { callMids88Api, getDeposit } from '../../../api/fastcoinService';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import 'jquery-ui-dist/jquery-ui';
import { getStrLang } from '../../Translate';


const Mids88 = (props) => {

    const { translate, lang } = useLanguage();
    const [loadingMids88Info, setLoadingMids88Info] = useState(false);
    const [infoMids88, setInfoMids88] = useState(sessionStorage.getItem("mids88_info") !== null ? JSON.parse(sessionStorage.getItem("mids88_info")) : {});
    const [waitingPayment, setWaitingPayment] = useState(sessionStorage.getItem("waiting_payment") !== null ? JSON.parse(sessionStorage.getItem("waiting_payment")) : false);
    const [isError, setIsError] = useState(false)
    const [erorMsg, setErrorMsg] = useState("")
    const [phoneNumber,setPhoneNumber]=useState("")

    useEffect(() => {
        translate();
    }, [translate]);



    const callProntoPaga = () => {
        setLoadingMids88Info(true);
        if (infoMids88[props.payment_type] === undefined) {
            callMids88Api(sessionStorage.getItem("order_no"), props.payment_type,phoneNumber)
                .then(res => {
                    if (res !== undefined) {
                        setInfoMids88({ ...infoMids88, [props.payment_type]: res });
                        sessionStorage.setItem("mids88_info", JSON.stringify({ ...infoMids88, [props.payment_type]: res }));
                        setLoadingMids88Info(false)
                    } else {
                        setErrorMsg("Please, talk with the Administrator.");
                        setLoadingMids88Info(false);
                        setIsError(true)
                    }
                })
                .catch(err => {
                    console.log(err.toString());
                    setErrorMsg(err.response?.data?.message ? err.response?.data?.message : "Internal server error")
                    setIsError(true)
                }).finally(() => {
                    setLoadingMids88Info(false);
                    translate();
                });
        }

    }

    useEffect(() => {
        let timeout;
        function checkPayment() {
            timeout = setTimeout(function () {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status.toLowerCase() === "paid") {
                            setWaitingPayment(false);
                            sessionStorage.setItem("waiting_payment", false);
                            window.location.replace(getURLBackToPanel());
                        } else {
                            checkPayment();
                        }
                    })
                    .catch(err => {
                        alert(err);
                        checkPayment();
                    })
            }, 30000);
        }
        if (waitingPayment) {
            sessionStorage.setItem("waiting_payment", true);
            checkPayment();
        }
        return () => clearTimeout(timeout);
    }, [loadingMids88Info]);


    useEffect(() => {
        if (infoMids88[props.payment_type] === undefined && props?.payment_type!=='payphone_payment') {
            callProntoPaga()
        }
        return () => {
            const iframe = document.getElementById('prontopaga_frame');
            if (iframe) {
                iframe.removeEventListener('load',()=>{})
            }
        }
    }, [])
    const [loading, setLoading] = useState(true);

    const handleLoad = () => {
        setLoading(false);
    };

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data && event.data.type === 'redirected') {
                const redirectedUrl = event.data.url;
                window.location.href=redirectedUrl
            }
        }
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    // console.log(infoMids88)
    const handlePhoneNumberChange = (e) => {
        let inputNumber = e.target.value;
        if (!inputNumber.startsWith('593')) {
            inputNumber = '593' + inputNumber;
        }
        setPhoneNumber(inputNumber); 
    };

    const callApi = (e) => {
        e.preventDefault();
        callProntoPaga()
    }
    
    return (
        <>
            {loadingMids88Info && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}


            {loadingMids88Info ===false && infoMids88[props.payment_type] === undefined && props?.payment_type === 'payphone_payment' && <>
                <div className='col-md-12 d-flex justify-content-center mt-5'>
                    <form style={{ minWidth: "100%" }} onSubmit={callApi}>
                        <div className='form-group'>
                            <label htmlFor="phone_number">{getStrLang(lang.nameLang, "phone_number")}</label>
                            <input type="number" className='form-control' id="phone_number" name="phone_number"
                                placeholder={`${getStrLang(lang.nameLang, "enter")} ${getStrLang(lang.nameLang, "phone_number")}`} value={phoneNumber}  onChange={handlePhoneNumberChange}
                                required />
                        </div>
                        <button type='submit' className='btn btn-primary btn-block'>{getStrLang(lang.nameLang, "pay")}</button>
                    </form>
                </div>
            </>}

            <div className=''>
                {infoMids88[props.payment_type] !== undefined ?
                    <>
                        <div style={{ width: '100%' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                {loading && <div className="loader"> <img src={Loading} alt={"loading"} width="30px" height="30px" /></div>}
                            </div>

                            <iframe
                                id='prontopaga_frame'
                                src={`${infoMids88[props.payment_type]['paymentUrl']}`}
                                title={`${props.payment_type}`}
                                width="100%"
                                height="800px"
                                onLoad={handleLoad}
                                style={{ display: loading ? 'none' : 'block' }}
                            />
                        </div>
                    </>
                    :
                    <>
                    </>
                }

                {isError && <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                    <h4>{erorMsg}</h4>
                </div>}
            </div>

        </>
    )
}

export default Mids88;